export enum FormMode {
	View = 0,
	Create = 1,
	Edit = 2,
}
